var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuth0UnlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8h-1V6A5 5 0 0 0 7.1 4.9L8.5 6.3A3 3 0 0 1 15 8v2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm0 10H6v-8h12v8zm-6-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth0UnlockIcon);
export default __webpack_public_path__ + "static/media/auth0_unlock_icon.7c671e648a94a05e9498743af424c3e8.svg";
export { ForwardRef as ReactComponent };